// src/utils/watchCardHandoff.js
// ============================================================================
// Channel card -> watch page handoff (10-15). A card on Streams or Home
// already shows the channel's thumbnail; handing it over lets the watch
// page draw that picture in the player box before getStreamPlayback
// answers. The server's answer always wins once it arrives.
//
// Memory only, never a navigation param: on web React Navigation writes
// extra params into the query string, which would put an image address in
// every shared /s/ link and let a crafted link swap the picture on a real
// channel. One slot, overwritten by the next card tap.
// ============================================================================

const MAX_AGE_MS = 5 * 60 * 1000;

let slot = null;

// card: a listStreamers / homeFeed row ({ thumbnailUrl, live }).
export const handOffStreamCard = (channel, card) => {
  if (!channel) return;
  slot = {
    channel: String(channel),
    thumbnailUrl: typeof card?.thumbnailUrl === 'string' && card.thumbnailUrl ? card.thumbnailUrl : null,
    // Only a card that said so counts as offline; unknown reads as maybe live.
    offline: card?.live === false,
    // Only a card that said so counts as live: the shell says "Starting
    // stream" only then (a shared link to an offline channel must not).
    live: card?.live === true,
    atMs: Date.now(),
  };
};

// The handoff for this channel param, or null (no card tap, another
// channel, or too old to trust).
export const peekStreamCard = (channel) => {
  if (!slot || !channel || slot.channel !== String(channel)) return null;
  if (Date.now() - slot.atMs > MAX_AGE_MS) return null;
  return slot;
};
